import './ListBox.css';

import { cn } from '##/utils/bem';

export const cnListBox = cn('ListBox');
